/**
 * Jitsi Meeting URL Generator
 * Generates unique Jitsi meeting room URLs
 */

const JITSI_DOMAIN = 'meet.jit.si';

/**
 * Generate a unique room name for Jitsi
 */
export function generateJitsiRoomName(prefix?: string): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 8);
  const roomPrefix = prefix?.replace(/[^a-zA-Z0-9]/g, '').substring(0, 20) || 'meeting';
  return `${roomPrefix}-${timestamp}-${random}`;
}

/**
 * Generate full Jitsi meeting URL
 */
export function generateJitsiMeetingUrl(roomName?: string, title?: string): string {
  const room = roomName || generateJitsiRoomName(title);
  return `https://${JITSI_DOMAIN}/${room}`;
}

/**
 * Extract room name from Jitsi URL
 */
export function extractRoomNameFromUrl(url: string): string | null {
  try {
    const urlObj = new URL(url);
    return urlObj.pathname.replace(/^\//, '');
  } catch {
    return null;
  }
}
